// extracted by mini-css-extract-plugin
module.exports = {"Host":"TaskList_Host_2pI5Q","Task":"TaskList_Task_1z9av"};